module.exports = __webpack_public_path__ + "img/en-reward2.06b5cfe1.jpg";